import "./features.css";

const Features = () => {
  return (
    <div
      className="features"
      role="region"
      aria-labelledby="features-heading"
      id="features"
    >
      <h2 className="home-headers" id="features-heading">
        Features
      </h2>
      <h3 className="features__subheading">
        More than just QR code tracking & analytics
      </h3>
      <div className="features__container">
        <div className="features__container__group">
          <div className="features__container__group__left">
            <img
              src="https://i.imgur.com/NOk0a4d.png"
              className="features__container__group__image"
              alt="QR code customization interface showing different appearance options"
            />
          </div>
          <div className="features__container__group__right">
            <h3 className="features__container__group__header">
              Fully Customisable
            </h3>
            <p className="features__container__group__paragraph">
              There are a wide range of different QR Code appearance options
              available. You can change the background colour, aswell as the
              pattern colour of your QR Code.
              <br></br>
              <br></br>
              You can choose from many different pattern shapes and even include
              an image in the center of your QR for branding.
            </p>
          </div>
        </div>
        <div className="features__container__group">
          <div className="features__container__group__left reverse">
            <h3 className="features__container__group__header">
              Detailed Analytics
            </h3>
            <p className="features__container__group__paragraph">
              With our Premium and Business plans you are able to track your
              marketing efforts. This is espeically useful when you're running
              multiple campaigns. Our Analytics system provides you with
              detailed bar charts, pie charts and statistics about your QR
              Codes.
            </p>
            <ul className="features__container__group__list" role="list">
              <li>Device Type</li>
              <li>Operating System</li>
              <li>GPS Location</li>
              <li>Pageviews</li>
              <li>Unique Pageviews</li>
            </ul>
          </div>
          <div className="features__container__group__right">
            <img
              src="https://i.imgur.com/GdHflaP.png"
              className="features__container__group__image"
              alt="Analytics dashboard showing QR code statistics and charts"
            />
          </div>
        </div>
        <div className="features__container__group">
          <div className="features__container__group__left">
            <img
              src="https://i.imgur.com/WlDQ558.png"
              className="features__container__group__image"
              alt="QR code management interface showing list of created QR codes"
            />
          </div>
          <div className="features__container__group__right">
            <h3 className="features__container__group__header">
              Manage your QR Codes
            </h3>
            <p className="features__container__group__paragraph">
              From your dashboard, you are able to manage a list of your QR
              Codes. From here you can create, modify, delete and view
              statistics on individual QR Codes.
            </p>
            <ul className="features__container__group__list" role="list">
              <li>Download QR Code</li>
              <li>Delete QR Code</li>
              <li>Edit QR Code</li>
              <li>View Statistics</li>
            </ul>
          </div>
        </div>
        <div className="features__container__group">
          <div className="features__container__group__left reverse">
            <h3 className="features__container__group__header">
              Editable QR Codes
            </h3>
            <p className="features__container__group__paragraph">
              Dynamic QR Codes allow you to change the the information related
              to your QR Code such as the destination that your code points to.
              This means you don't have to create a new QR Code if your URL
              changes.
              <br></br>
              <br></br>
              This is especially important for businesses who intend to use QR
              Codes for leaflet and business card marketing who will print out
              their QR Codes.
            </p>
          </div>
          <div className="features__container__group__right">
            <img
              src="https://i.imgur.com/NFjEWuN.png"
              className="features__container__group__image"
              alt="Interface showing editable QR code settings and options"
            />
          </div>
        </div>
      </div>
      <button
        className="home-cta-btn"
        aria-label="Get started with QRSharp for free"
      >
        Get Started for Free
      </button>
    </div>
  );
};

export default Features;
